export default "__VITE_ASSET__AUqwHABF__"